import * as MsalAuth from "./authConfig";
import * as FmMsalAuth from "./fmAuthConfig";

export async function callApiWithMsal(idToken, accessToken, fetch, url, options = {}) {
    const headers = new Headers(options.headers || {});
    const bearer = `Bearer ${idToken}`;
    headers.set("Authorization", bearer);
    headers.set("X-Access-Token", accessToken);

    if (!options.method) {
        options.method = "GET";
    }

    options.credentials = "same-origin";
    options.headers = headers;

    return await fetch(url, options);
}

export const msalApiFetch = async (fetch, url, options) => {
    console.log("msalApiFetch called with url:", url);   
    
    var authResult = await MsalAuth.authToken();
    var idToken = authResult.idToken;
    var accessToken = authResult.accessToken;

    return await callApiWithMsal(idToken, accessToken, fetch, url, options);
}

export const msalApiFetchForFinalmile = async (fetch, url, options) => {
    console.log("msalApiFetchForFinalmile called with url:", url);   
    
    var authResult = await FmMsalAuth.fmAuthToken();
    var idToken = authResult.idToken;
    var accessToken = authResult.accessToken;

    return await callApiWithMsal(idToken, accessToken, fetch, url, options);
}